import { CapacityState } from 'services/metrics/types'

export const getCapacityState = (
  activePatients: number,
  recurringSlots: number,
): CapacityState => {
  if (activePatients === 0 && recurringSlots === 0) return 'empty'
  if (activePatients < recurringSlots) return 'below'
  if (activePatients === recurringSlots) return 'equal'
  return 'above'
}
